import styled from "styled-components";
import { Container } from "../../../components/navbar/Nav.styles";
import { CaptionText } from "./AboutSession";
import { Button } from "./HeroSession.js/HeroSession.styles";

export const OurProduct = () => {
  return (
    <Container>
      <ProductCaptionText>Our Products</ProductCaptionText>
      <ProductCardLeft>
        <div>
          <img
            src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651540953/invest-trust/Rectangle_9118_vakeeo.png"
            alt="betalife"
          />
        </div>
        <div>
          <h2>Beta Life</h2>
          <p>
            This is a product for Relocation. This is a target locked savings
            plan that can help people save towards their relocation plan. This
            is a 2in1 product, which helps to save and at the same time provide
            adequate proof of funds.
          </p>
          <BetaButton>
            <Button outline="outline" to="/product">
              Learn More
            </Button>
          </BetaButton>
        </div>
      </ProductCardLeft>
      <ProductCardRight>
        <div>
          <h2>Auto Loan</h2>
          <p>
            This product is driven to assist people in buying their desired
            cars. It will also be driven by target savings such that the
            beneficiary would have saved up to 30%-50% of the cost of the
            vehicle over a period of time.
          </p>
          <BetaButton>
            <Button outline="outline" to="/product/auto-loan">
              Learn More
            </Button>
          </BetaButton>
        </div>
        <div>
          <img
            src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651540954/invest-trust/Rectangle_9119_vsjlp3.png"
            alt="AutoLoan"
          />
        </div>
      </ProductCardRight>
      <ProductCardLeft>
        <div>
          <img
            src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651540953/invest-trust/Rectangle_9120_kxovxv.png"
            alt="betalife"
          />
        </div>
        <div>
          <h2>Payday Credit</h2>
          <p>
            This is a credit facility available to people who ahead of their
            payday need to attend to unforeseen contingencies. Sometimes
            emergencies arise before payday and with our payday credit you can
            be low on cash.
          </p>
          <BetaButton>
            <Button outline="outline" to="/product/payday">
              Learn More
            </Button>
          </BetaButton>
        </div>
      </ProductCardLeft>
      <ProductCardLeft>
        <div>
          <img
            src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651540953/invest-trust/Rectangle_9120_1_ohhfpt.png"
            alt="betalife"
          />
        </div>
        <div>
          <h2>Children Education Plan</h2>
          <p>
            Secure the future of your child as a parent .this product will help
            you meet up your children future education needs.This is designed to
            help children follow their educational pursuits.
          </p>
          <BetaButton>
            <Button outline="outline" to="/product/edu">
              Learn More
            </Button>
          </BetaButton>
        </div>
      </ProductCardLeft>
      <ProductCardRight>
        <div>
          <h2>School Fees Advance</h2>
          <p>
            School fees advance Is a loan that offers to finance the payment of
            tuition fees for tertiary institutions only. This product is so that
            they can save up about 50% of their ward’s tuition fee ahead of the
            payment time considering that Private University school fees are a
            bit on the high side.
          </p>
          <BetaButton>
            <Button outline="outline" to="/product/school-fees">
              Learn More
            </Button>
          </BetaButton>
        </div>
        <div>
          <img
            src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651540953/invest-trust/Rectangle_9119_1_cgs9nl.png"
            alt="AutoLoan"
          />
        </div>
      </ProductCardRight>
      <ProductCardLeft>
        <div>
          <img
            src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651540954/invest-trust/Rectangle_9120_2_fba1zm.png"
            alt="betalife"
          />
        </div>
        <div>
          <h2>Jolly Jolly</h2>
          <p>
            This product is geared to enable people who wants to travel on
            vacation achieve their dream.You can save 50% of the vacation cost
            with our target/locked savings within a period of time. Interest
            rate of 3.5%-5% depending on the duration of loan. Jolly jolly can
            also be used to go on pilgrimage(Mecca and Jerusalem).
          </p>
          <BetaButton>
            <Button outline="outline" to="/product/jolly-jolly">
              Learn More
            </Button>
          </BetaButton>
        </div>
      </ProductCardLeft>
    </Container>
  );
};

export const ProductCaptionText = styled(CaptionText)`
  margin-bottom: 0rem;
  text-align: left;
  color: #e3e4f0;
  line-height: 128px;
  margin-bottom: 6rem;
  @media screen and (max-width: 991px) {
    font-size: 6rem;
    text-align: center;
    line-height: 88px;
    margin-bottom: 2rem;
    // margin-right: 5rem;
  }
  @media screen and (max-width: 579px) {
    margin-top: -7rem;
    font-size: 4rem;
    text-align: center;
    line-height: 80px;
    margin-bottom: 2rem;
  }
`;
export const ProductCardLeft = styled.div`
  margin-top: 5rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7rem;

  img {
    max-width: 100%;
  }

  div h2 {
    margin-bottom: 0rem;
    font-family: "Futura";
    font-weight: 200;
  }
  div p {
    margin-top: 0.5rem;
    font-size: 20px;
    width: 100%;
  }

  div:nth-of-type(2) h2 {
    text-align: left;
    font-size: 2.5rem;

    color: ${({ theme }) => theme.colors.body};
  }

  div:nth-of-type(2) p {
    text-align: left;
    font-size: 22px;
    font-weight: 400;
    line-height: 2rem;
    padding-right: 4rem;
  }

  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    gap: 0rem;

    div: nth-of-type(2) h2 {
      text-align: center;
    }
    div: nth-of-type(2) p {
      text-align: center;
      padding-right: 0rem;
    }
  }

  @media screen and (max-width: 579px) {
    div: nth-of-type(2) h2 {
      margin-top: .4rem;
        margin-bottom: 1rem;
        line-height: 48px;
    }
    div: nth-of-type(2) p {
      font-size: 20px;
      margin-top: -1rem;
    }
  }
`;

export const BetaButton = styled.div`
  font-size: 16px;
  font-weight: 500;
  display: flex;
  padding: 1rem 0.5rem;
  line-height: 32px;

  a:hover {
    color: ${({ theme }) => theme.colors.text};
  }

  @media screen and (max-width: 991px) {
    display: flex;
    justify-content: center;
  }
  @media screen and (max-width: 579px) {
    // font-size: 18px;
    // margin-top: -1rem;
  }
`;

export const ProductCardRight = styled(ProductCardLeft)`
  div:nth-of-type(2) {
    @media screen and (max-width: 991px) {
      grid-row-start: 1;
      grid-row-end: 3;
    }
  }
  div:nth-of-type(1) h2 {
    text-align: left;
    font-size: 2.5rem;
    color: ${({ theme }) => theme.colors.body};
    @media screen and (max-width: 991px) {
      text-align: center;
    }
    @media screen and (max-width: 579px) {
      margin-top: 0.4rem;
      margin-bottom: 1rem;
      line-height: 48px;
    }
  }
  div:nth-of-type(1) p {
    text-align: left;
    font-size: 22px;
    font-weight: 400;
    line-height: 32px;
    // padding-right: 1rem;

    color: ${({ theme }) => theme.colors.primary};
    @media screen and (max-width: 991px) {
      text-align: center;
      padding-right: 0rem;
      // margin-right: 5rem;
    }
    @media screen and (max-width: 579px) {
      font-size: 20px;
      margin-top: -1rem;
    }
  }
`;
